import { EntityDetailData, EntityDto } from '@/apiClient';
import { Param } from './constants';

export const findEntityDetailValue = (
  entity: EntityDto,
  entityDetail: EntityDetailData,
) => {
  return entity.entityDetailValues?.find(
    (value) => value.entityDetailId === entityDetail.entityDetailId,
  );
};

export function formatPath(path: string, search: string) {
  return search ? `${path}?${search}` : path;
}

export function getParamAsString(
  key: keyof typeof Param,
  params: URLSearchParams,
) {
  return String(params.get(key) || Param[key].default);
}

export const setSearchParam = (name: string, value?: boolean | string) => {
  const params = new URLSearchParams(location.search);

  if (value) {
    params.set(name, value === true ? 'true' : value);
  } else {
    params.delete(name);
  }

  // history instead of next/navigation to prevent additional page refetch
  // because app router no longer supports shallow routing
  // replaceState instead of pushState to prevent browser back button from reloading the page
  history.replaceState(
    {},
    '',
    formatPath(location.pathname, params.toString()),
  );
  const event = new Event('replaceState');
  window.dispatchEvent(event);
};
